import DataQueries                  from '../graphql/Queries';
import areaDialogModel              from '../schedule/AreaDialogModel';
import {
  DefaultSchema,
  IEditPanelView
}                                   from './SettingsModel';
import mainPageModel                from '../main-navigation/MainPageModel';
import { MasterDataSettingsModel }  from './MasterDataSettingsModel';
import archiveDeleteAreaDialogModel from './ArchiveDeleteAreaDialogModel';
import AreaEditPanelView            from './AreaEditPanelView';
import { AreaSort }                 from '../DataTypes';

export default class AreasSettingsModel extends MasterDataSettingsModel {
  constructor() {
    super('Area', 'areas', areaDialogModel);

    this.EditPanelView = AreaEditPanelView as IEditPanelView;;
  }

  get _canAddItem(): boolean {
    return mainPageModel.canAddAreas;
  }

  get _canEditItem(): boolean {
    return mainPageModel.canEditAreas;
  }

  get _canDeleteItem(): boolean {
    return mainPageModel.canDeleteAreas;
  }

  protected async _load(filter: {search?: string}, sort?: AreaSort) {
    const results = (await DataQueries.getAreas(DefaultSchema + ' archived', filter, sort, this.paging.itemsPerPage, this.paging.currentPage));
    this.setItems(results.data);
    return results;
  }

  archive = async () => {
    archiveDeleteAreaDialogModel.load(this.selectedItem, 'archive');
  };

  handleArchiveOnSubmit = () => {
    this.paging.load(true);
  };

  removeItem = async () => {
    if (!this.selectedItem) return;
    archiveDeleteAreaDialogModel.load(this.selectedItem, 'delete');
  };

  handleDeleteOnSubmit = () => {
    const selectedIdx = this.state.items.findIndex(i => i.id === this.selectedItem.id);
    if (selectedIdx >= 0) this.state.items.splice(selectedIdx, 1);
    this._selectItem(undefined);
  };

  activate() {
    const isActive = this.isActive;
    super.activate();
    if (!isActive) {
      archiveDeleteAreaDialogModel.onEvent.addListener('archive', this.handleArchiveOnSubmit);
      archiveDeleteAreaDialogModel.onEvent.addListener('delete', this.handleDeleteOnSubmit);
    }
  }

  deactivate() {
    const isActive = this.isActive;
    super.deactivate();
    if (isActive) {
      archiveDeleteAreaDialogModel.onEvent.removeListener('archive', this.handleArchiveOnSubmit);
      archiveDeleteAreaDialogModel.onEvent.removeListener('delete', this.handleDeleteOnSubmit);
    }
  }
}
